import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { useTFF } from "@hooks/useTFF"
import { useHydrating, useRoute, useRouter } from "eddev/routing"
import { defineView } from "eddev/views"
import { useEffect, useMemo } from "react"

export default defineView("single-tff-center", (props) => {
  const hydrating = useHydrating()
  const tff = useTFF()

  const blocks = useMemo(() => {
    const programBlock = props.tffCenter?.contentBlocks.find((block) => block.slug === "tff-center/tff-center-program")
    const ticketsSlot = programBlock?.innerBlocks?.find(
      (block) => block.blockName === "core/slot-group" && block.slotId === "tickets-page",
    )
    return ticketsSlot?.innerBlocks
  }, [props])

  const router = useRouter()
  useEffect(() => {
    const preferred = sessionStorage.getItem("lastTffCenter") || null
    if (tff.routeCenter) {
      router.navigate(`/tff/tickets/${tff.centerSlug}`)
    } else if (preferred) {
      router.navigate(`/tff/tickets/${preferred}`)
    }
  }, [tff.centerSlug, hydrating])

  return (
    <div>
      <SubpageContentBlocks blocks={blocks} />
      <div className="h-10" />
    </div>
  )
})
